import styled, { CSSObject } from "@emotion/styled"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FusionColor } from "../../../theme/FusionStyle"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type V2L1DesignatorGelColor = FusionColor.OrangeLight2|FusionColor.BlueLight2|FusionColor.ErrorRed

interface V2L1DesignatorGelRootProps {
	color: V2L1DesignatorGelColor
}

const V2L1DesignatorGelRoot = styled.div<V2L1DesignatorGelRootProps>(({theme, color}) => {
	const style: CSSObject = {
		borderRadius: theme.borderRadius2,
		padding: '.25rem .75rem',
		display: 'inline-flex',
		flexDirection: 'row',
		alignItems: 'center',
		columnGap: '.5rem',
		...theme.fonts.bodyBold,
		fontSize: `${14/16}rem`,
		'svg': {
			fontSize: `${12/16}rem`,
		}
	}
	switch(color) {
		case FusionColor.OrangeLight2:
			return {
				...style,
				backgroundColor: theme.colors[FusionColor.OrangeLight2],
				color: theme.colors.menu,
			}
		case FusionColor.BlueLight2:
			return {
				...style,
				backgroundColor: theme.colors[FusionColor.BlueLight2],
				color: theme.colors.blueDark,
			}
		case FusionColor.ErrorRed:
			return {
				...style,
				backgroundColor: theme.colors[FusionColor.ErrorRed],
				color: theme.colors.stopRed,
			}
	}
	return style
})

interface V2L1DesignatorGelProps {
	icon: IconProp
	color: V2L1DesignatorGelColor
	title: string
}

export const V2L1DesignatorGel = ({icon, color, title}: V2L1DesignatorGelProps) => {
	return (
		<V2L1DesignatorGelRoot color={color}>
			<FontAwesomeIcon icon={icon} />
			<div>{title}</div>
		</V2L1DesignatorGelRoot>
	)
}
